<div
  class="avatar"
  [ngClass]="[size || '', state || '', additionalClass || '']"
>
  <ng-container *ngIf="!showInitials; else initialsTemplate">
    <img
      *ngIf="src"
      [src]="src"
      [alt]="alt || 'Avatar'"
      (error)="onImageError()"
      class="avatar-image"
    />
  </ng-container>
  <ng-template #initialsTemplate>
    <span class="avatar-initials">
      {{ initials ? initials.slice(0, 2).toUpperCase() : 'NA' }}
    </span>
  </ng-template>
</div>
